import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-services-read-more',
  templateUrl: './service-read-more.component.html',
  styleUrls: ['./service-read-more.component.scss']
})
export class ServiceReadMoreComponent implements OnInit {

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
  }

  ortho = [
    { img: "assets/images/services/spinal.jpg", title: 'Back and neck pain' },
    { img: "assets/images/services/mobilisation.jpg", title: 'Joint problems' },
    { img: "assets/images/services/post-opp.jpg", title: 'Post-operative rehabilitation' },
    { img: "assets/images/services/Dry-Needling.jpg", title: 'Dry needling' },
    { img: "assets/images/services/sports-injury.jpeg", title: 'Sports injuries' },
  ]

  neuro = [
    { img: "assets/images/services/stroke.jfif", title: 'Rehabilitation after stroke or head injury' },
    { img: "assets/images/services/neurodevelopment.jpg", title: 'Neuro-developmental treatment for children' },
    { img: "assets/images/services/covid.jfif", title: 'Post-Covid rehabilitation' },
    { img: "assets/images/services/chronic-rehab.jfif", title: 'Rehabilitation for chronic conditions' },
  ]

  respiratory = [
    { img: "assets/images/services/lung-rehab.jfif", title: 'Rehabilitation for chronic lung conditions' },
    { img: "assets/images/services/covid.jfif", title: 'Post-Covid recovery' },
    { img: "assets/images/services/acute-resp.jfif", title: 'Acute respiratory conditions' },
    { img: "assets/images/services/sinus.jfif", title: 'Sinusitis' },
    { img: "assets/images/services/lung-respiro.jpg", title: 'Manual techniques (eg percussion, vibration)' },
    { img: "assets/images/services/breathing.jfif", title: 'Breathing re-education' },
    { img: "assets/images/services/nebuliser.jfif", title: 'Nebulisation, intermittent positive pressure ventilation' },
  ]

  pilates = [
    { img: "assets/images/services/pilates.jfif", title: 'Group or individual sessions' },
  ]

  womens = [
    { img: "assets/images/services/pelvic.jfif", title: 'Pelvic floor rehabilitation post-surgery or delivery' },
    { img: "assets/images/services/mastitis.jfif", title: 'Treatment for mastitis and associated conditions' },
  ]

  home = [
    { img: "assets/images/services/home.jfif", title: 'Within a 5km radius of the practice and for medical reasons' },
  ]

}

